<template>
  <div class="signup">
    <div class="content">
      <img class="logo" src="../assets/qs1.svg" />
      <p class="title">Introduce tu nueva contraseña</p>

      <ApolloMutation
        class="wrapper"
        :mutation="require('../graphql/ResetPassword.gql')"
        :variables="{
          password: this.password,
          repeatPassword: this.repeatPassword,
          userId: this.userId,
          token: this.token
        }"
        @done="onDone"
      >
        <template v-slot="{ mutate, loading, error }">
          <p v-if="error">An error occurred: {{ error }}</p>
          <form class="form" v-on:submit.prevent="mutate()">
            <input
              class="field"
              type="password"
              v-model="password"
              placeholder="Nueva contraseña"
              id="pass"
            />
            <input
              class="field"
              type="password"
              v-model="repeatPassword"
              placeholder="Repite contraseña"
              id="pass"
            />
            <div>
              <el-button class="send" type="primary" native-type="submit"
                >Enviar</el-button
              >
            </div>
          </form>
        </template>
      </ApolloMutation>
    </div>

    <Footer />
  </div>
</template>

<script>
import Footer from '@/components/Footer'

export default {
  name: 'Signup',
  components: {
    Footer
  },
  data () {
    return {
      userId: this.$route.params.user,
      token: this.$route.params.token,
      password: '',
      repeatPassword: '',
      submited: false
    }
  },
  methods: {
    onDone (e) {
      this.$router.push('/')
    },
    goToNextStep () {
      this.step += 1
    },
    updateToken (store, response) {
      // pass token and firebaseToken
      this.$store.dispatch('login', response.data.signin)
    }
  },
  computed: {
    formValid () {
      return true
    },
    formSubmited () {
      return this.submited
    }
  }
}
</script>

<style scoped lang="scss">
.signup {
  box-sizing: border-box;
  min-height: 100vh;
  display: grid;
  grid-template-rows: 1fr auto;
  padding: 24px;

  .signup {
    width: min-content;
    justify-self: flex-end;
  }

  .content {
    align-items: center;
    display: flex;
    flex-direction: column;
    justify-content: center;

    .logo {
      height: 170px;
    }

    .title {
      color: #000000;
      font-size: 26px;
      font-weight: 500;
    }

    .wrapper {
      width: 100%;
      display: flex;
      justify-content: center;
      .form {
        display: flex;
        flex-direction: column;
        width: 100%;
        max-width: 288px;
        align-self: center;
        justify-self: center;

        .field {
          margin-bottom: 16px;

          &:last-of-type {
            margin-bottom: 8px;
          }
        }

        .password-recovery {
          width: max-content;
          margin-bottom: 16px;
          display: block;
          color: black;
          font-size: 14px;
        }

        .send {
          width: 100%;
          margin-bottom: 24px;
        }
      }
    }
  }
}
</style>
